import * as React from "react";
import { Control, Controller } from "react-hook-form";

import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import type { SxProps } from "@mui/material/styles";

import { AppointmentFormValues } from "../appointment-form.component";

type NotesFieldProps = {
  control: Control<AppointmentFormValues, object>;
  placeholder?: string;
  sx?: SxProps;
};

export default function NotesField({
  control,
  placeholder = "Appointment Notes",
  sx
}: NotesFieldProps) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ ...sx }}
    >
      <ContentPasteOutlinedIcon sx={{ mt: 0.5, mr: 1.5 }} />
      <Controller
        name="notes"
        control={control}
        render={({ field }) => (
          <TextField
            placeholder={placeholder}
            multiline
            fullWidth
            {...field}
            sx={{ "& textarea": { minHeight: 50 } }}
          />
        )}
      />
    </Box>
  );
}
